import * as React from "react"

function ErrorBox(props) {
  return (
    <svg viewBox="0 0 554.75 486.06" {...props}>
      <defs>
        <style>
          {".prefix__cls-1{fill:#f4d3d3}.prefix__cls-2{fill:#d89a9a}"}
        </style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <g id="prefix__Layer_2-2" data-name="Layer 2">
            <g id="prefix__Layer_1-2-2" data-name="Layer 1-2">
              <path
                className="prefix__cls-1"
                d="M29.84 252h130.79a16.58 16.58 0 0115.13 9.82l16 35.53a10 10 0 009.09 5.9h153.08a10 10 0 009.09-5.9l16-35.57a16.55 16.55 0 0115.1-9.78h130.79a28.88 28.88 0 018.16 1.15L458.83 106A23.22 23.22 0 00438 93.14H116.73A23.18 23.18 0 0095.92 106L21.68 253.05a29.62 29.62 0 018.16-1.05z"
              />
              <path
                className="prefix__cls-2"
                d="M554.75 281.44a32.85 32.85 0 00-4.65-16.84l-82.35-163.18A33.13 33.13 0 00438 83.14H116.73A33.13 33.13 0 0087 101.43L4.67 264.6A32.82 32.82 0 000 280.27v175.89a29.9 29.9 0 0029.84 29.9h495.07a29.9 29.9 0 0029.84-29.9v-102zm-10 174.72a19.89 19.89 0 01-19.84 19.9H29.84A19.89 19.89 0 0110 456.16V281.82A19.89 19.89 0 0129.84 262h130.79a6.55 6.55 0 016 3.91l16 35.54a20 20 0 0018.21 11.8h153.09a20 20 0 0018.21-11.8l16-35.58a6.55 6.55 0 016-3.87h130.77a19.89 19.89 0 0119.84 19.91zM96 105.94a23.2 23.2 0 0120.81-12.8H438A23.22 23.22 0 01458.83 106l74.24 147.1a28.88 28.88 0 00-8.16-1.15H394.12a16.54 16.54 0 00-15.12 9.74l-16 35.57a10 10 0 01-9.09 5.9H200.82a10 10 0 01-9.09-5.9l-16-35.53a16.57 16.57 0 00-15.1-9.77H29.84a29.24 29.24 0 00-8.16 1.14z"
              />
              <path
                d="M544.75 281.82A19.89 19.89 0 00524.91 262H394.12a6.55 6.55 0 00-6 3.87l-16 35.58a20 20 0 01-18.21 11.8H200.82a20 20 0 01-18.21-11.8l-16-35.54a6.55 6.55 0 00-6-3.91H29.84A19.89 19.89 0 0010 281.82v174.34a19.89 19.89 0 0019.84 19.9h495.07a19.89 19.89 0 0019.84-19.9zM354.38 409.1a16.48 16.48 0 01-16.47 16.46H216.84a16.48 16.48 0 01-16.46-16.46V376a16.48 16.48 0 0116.46-16.47h121.07A16.48 16.48 0 01354.38 376z"
                fill="#ffebeb"
              />
              <rect
                x={210.38}
                y={369.56}
                width={134}
                height={46}
                rx={6.47}
                fill="#ffe1e1"
              />
              <path
                className="prefix__cls-2"
                d="M337.91 359.56H216.84A16.48 16.48 0 00200.38 376v33.1a16.48 16.48 0 0016.46 16.46h121.07a16.48 16.48 0 0016.47-16.46V376a16.48 16.48 0 00-16.47-16.44zm6.47 49.54a6.48 6.48 0 01-6.47 6.46H216.84a6.48 6.48 0 01-6.46-6.46V376a6.48 6.48 0 016.46-6.47h121.07a6.49 6.49 0 016.47 6.47z"
              />
            </g>
          </g>
          <path
            className="prefix__cls-1"
            d="M449.14 88.27l54.48-54.48a8.66 8.66 0 000-12.26l-9-9a8.67 8.67 0 00-12.26 0L427.89 67l-54.48-54.46a8.67 8.67 0 00-12.26 0l-9 9a8.66 8.66 0 000 12.26l54.49 54.48-54.49 54.49a8.65 8.65 0 000 12.25l9 9a8.67 8.67 0 0012.26 0l54.48-54.48L482.38 164a8.67 8.67 0 0012.26 0l9-9a8.65 8.65 0 000-12.25z"
          />
          <path
            className="prefix__cls-2"
            d="M510.69 135.69l-47.41-47.42 47.41-47.41a18.69 18.69 0 000-26.4l-9-9a18.66 18.66 0 00-26.4 0l-47.4 47.42-47.41-47.41a18.66 18.66 0 00-26.4 0l-9 9a18.66 18.66 0 000 26.4l47.42 47.4-47.41 47.42a18.66 18.66 0 000 26.4l9 9a18.66 18.66 0 0026.4 0l47.41-47.41 47.42 47.41a18.66 18.66 0 0026.4 0l9-9a18.69 18.69 0 00-.03-26.4zM503.62 155l-9 9a8.67 8.67 0 01-12.26 0l-54.49-54.48L373.41 164a8.67 8.67 0 01-12.26 0l-9-9a8.65 8.65 0 010-12.25l54.49-54.49-54.48-54.47a8.66 8.66 0 010-12.26l9-9a8.67 8.67 0 0112.26 0L427.89 67l54.49-54.48a8.67 8.67 0 0112.26 0l9 9a8.66 8.66 0 010 12.26l-54.5 54.49 54.48 54.49a8.65 8.65 0 010 12.24z"
          />
        </g>
      </g>
    </svg>
  )
}

export default ErrorBox



// WEBPACK FOOTER //
// ./src/components/Search/ErrorBox.js